import { render, staticRenderFns } from "./teacherAuthority.vue?vue&type=template&id=b1fe3a4c&scoped=true&"
import script from "./teacherAuthority.vue?vue&type=script&lang=js&"
export * from "./teacherAuthority.vue?vue&type=script&lang=js&"
import style0 from "./teacherAuthority.vue?vue&type=style&index=0&id=b1fe3a4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fe3a4c",
  null
  
)

export default component.exports